/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface WorkReason {
  type?: 'work';
  company_name: string;
  from_month: string;
  to_month: string;
  months: number;
  same_function: boolean;
}
